import { ADVICE_REQUESTS_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'
import { MutationDeleteSalesArgs } from 'packages/lawyers/interfaces/schemaDefinition'

import query from '../graphql/deleteSales.graphql'

export const deleteSales = async (adviceRequestId: string, revenueId: string) => {
  try {
    await request<MutationDeleteSalesArgs>(ADVICE_REQUESTS_ENDPOINT, query, {
      adviceRequestId,
      revenueId,
    })
  } catch (error) {
    throw error
  }
}
